import { experimentStates, experimentFlagsHelper } from '@zola-helpers/client';

const { CONTROL } = experimentStates;

// Experiment Keys
export const VIRTUAL_EVENTS = 'virtual-events';
export const ALL_PLANNING_DASH = 'all-planning-dash';
export const UNIFY_PAPER_ACCOUNT = 'unify-paper-account';
export const ONBOARD_CITY_STATE = 'onboard-city-state';
export const WEB_TO_REGISTRY_HERO = 'web-to-registry-hero';
export const ZOOM_UPGRADE = 'zoom-upgrade'; //  CE-614, Added 1/6/2021
export const POST_ONBOARD_MOBILE_A1 = 'post-onboard-mobile-a1'; // CE-641, 1/27/2021
export const POST_ONBOARD_MOBILE_A2 = 'post-onboard-mobile-a2'; // CE-641, 1/27/2021
export const POST_ONBOARD_MOBILE_B1 = 'post-onboard-mobile-b1'; // CE-641, 1/27/2021
export const INVITES_PROMO_PAPER40 = 'invites-promo-paper40';
export const DESKTOP_SELECT_PRODUCT = 'desktop-select-product'; // CE-700 1/12/2021
export const LOGROCKET_PLANNING_ONBOARD_FLAG = 'logrocket-planning-onboard';
export const MAGIC_LINK = 'magic-link'; // CE-673 2/24/2021

const FALLBACK_VARIATIONS = {
  [VIRTUAL_EVENTS]: experimentFlagsHelper.createExperimentFlags(CONTROL, CONTROL, CONTROL),
  [ALL_PLANNING_DASH]: experimentFlagsHelper.createExperimentFlags(),
  [UNIFY_PAPER_ACCOUNT]: experimentFlagsHelper.createExperimentFlags(),
  [ONBOARD_CITY_STATE]: experimentFlagsHelper.createExperimentFlags(),
  [WEB_TO_REGISTRY_HERO]: experimentFlagsHelper.createExperimentFlags(),
  [ZOOM_UPGRADE]: experimentFlagsHelper.createExperimentFlags(),
  [POST_ONBOARD_MOBILE_A1]: experimentFlagsHelper.createExperimentFlags(),
  [POST_ONBOARD_MOBILE_A2]: experimentFlagsHelper.createExperimentFlags(),
  [POST_ONBOARD_MOBILE_B1]: experimentFlagsHelper.createExperimentFlags(),
  [INVITES_PROMO_PAPER40]: experimentFlagsHelper.createExperimentFlags(),
  [DESKTOP_SELECT_PRODUCT]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_PLANNING_ONBOARD_FLAG]: experimentFlagsHelper.createExperimentFlags(),
  [MAGIC_LINK]: experimentFlagsHelper.createExperimentFlags(),
};

export default experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);



// WEBPACK FOOTER //
// ./src/util/experimentFlags.js